import Layout from "components/wrappers/Layout";
import Theme from "styles/theme";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import ScrollToTop from "components/assets/utilities/ScrollToTop";
import SessionProvider from "components/wrappers/SessionProvider";
import RunPageSelector from "components/wrappers/RunPageSelector";
import { useEffect } from "react";
import { useAppSelector } from "redux/hooks";
import Home from "./components/pages/Home";
import ModelPage from "./components/pages/Model";
import QACheckPage from "./components/pages/QA";
import ResultPage from "./components/pages/Result";
import JobPage from "./components/pages/Job";
import ModelFlowPage from "components/pages/Flow";
import FeedbackPage from "components/pages/Feedback";
import ChatPage from "components/pages/Chat";

function RedirectToDefaultModel() {
    const defaultModel = useAppSelector(state => state.user.settings?.default_model);

    useEffect(() => {
        window.location.replace(`/${encodeURIComponent(defaultModel)}`);
    }, [defaultModel]);
    return null;
}

function App() {
    const isAdmin = useAppSelector(state => state.user.settings?.is_admin ?? false);

    return (
        <ThemeProvider theme={Theme}>
            <SessionProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Layout>
                        <Routes>
                            {!isAdmin && (
                                <Route path="/" element={<RedirectToDefaultModel />} />
                            )}
                            {isAdmin && (
                                <>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/chat" element={<ChatPage />} />
                                    <Route path="/:modelName/info" element={<ModelPage />} />
                                    <Route path="/:modelName/qa"  element={<QACheckPage />} />
                                    <Route path="/:modelName/flow" element={<ModelFlowPage />} />
                                    <Route path="/:modelName/feedback" element={<FeedbackPage />} />
                                    <Route path="/:modelName/job/:jobName" element={<JobPage />} />
                                    <Route path="/:modelName/results/:resultName" element={<ResultPage />} />
                                </>
                            )}
                            <Route path="/:modelName"  element={<RunPageSelector />} />
                        </Routes>
                    </Layout>
                </BrowserRouter>
            </SessionProvider>
        </ThemeProvider>
    );
}

export default App;
